import { formatDate } from "cms/utils/format-date";

export const columns = [
    {
        field: "permit_number",
        width: 150,
        cellClassName: "permit-name-cell",
        headerClassName: "permit-grid-column-title",
        headerName: "Permit Number",
    },
    {
        field: "main_address",
        width: 200,
        cellClassName: "permit-name-cell",
        headerClassName: "permit-grid-column-title",
        headerName: "Main Address",
    },
    {
        field: "valuation_value",
        width: 100,
        headerClassName: "permit-grid-column-title",
        headerName: "Value",
    },
    {
        field: "contact",
        width: 200,
        headerName: "Contact",
        valueGetter: (params) => {
            return {
                contact_first_name: params.row.contact_first_name,
                contact_middle_name: params.row.contact_middle_name,
                contact_last_name: params.row.contact_last_name,
                contact_company_name: params.row.contact_company_name,
            };
        },
        renderCell: (params) => {
            const { contact_first_name, contact_middle_name, contact_last_name, contact_company_name } = params.value;
            return (
                <div className="permit-grid-column-custom-value">
                    <div>{contact_company_name}</div>
                    <div>{contact_first_name} {contact_middle_name} {contact_last_name}</div>
                </div>
            );
        },
    },
    {
        field: "permit_status",
        width: 100,
        headerClassName: "permit-grid-column-title",
        headerName: "Status",
    },
    {
        field: "issue_date",
        width: 150,
        headerClassName: "permit-grid-column-title",
        headerName: "Issued Date",
        renderCell: (params) => {
            return formatDate(new Date(params.value), "YYYY/MM/DD");
        },
    },
    {
        field: "permit_type",
        width: 100,
        cellClassName: "permit-grid-column-custom-value",
        headerClassName: "permit-grid-column-title",
        headerName: "Type",
    },
    {
        field: "permit_description",
        width: 200,
        cellClassName: "permit-grid-column-custom-value",
        headerClassName: "permit-grid-column-title",
        headerName: "Description",
    },
];
